import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_ACCESS_RULES } from '../get-access-rules';
import { updateAccessRulesAPI } from './api';

export function useUpdateAccessRule() {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation(({ id, ...data }) => updateAccessRulesAPI(id, data), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_ACCESS_RULES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'success', description: 'accessRuleUpdatedSuccessfully' },
      });
    },
    onError: (error) => {
      if (error?.errorMessage?.includes('already exists')) {
        openModal({
          modalType: 'NotificationModal',
          modalProps: { type: 'error', description: 'accessRuleNameAlreadyExists' },
        });
      } else {
        openModal({
          modalType: 'NotificationModal',
          modalProps: { type: 'error', description: 'genericErrorMessage' },
        });
      }
    },
  });

  return {
    updateAccessRule: mutation.mutate,
    updateAccessRuleAsync: mutation.mutateAsync,
    ...mutation,
  };
}

